import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import Vantagem from '../../../../assets/icons/vantagem.png';
import Desvantagem from '../../../../assets/icons/desvantagem.png';
import Tecnologia from '../../../../assets/icons/tecnologia.png';
import Sinal from '../../../../assets/icons/roteador.png';
import Custo from '../../../../assets/icons/dinheiro.png';

import 'bootstrap/dist/css/bootstrap.min.css';

import './Wifi62.css';

function Wifi62() {
  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-sm-12'>
            <h1>Tecnologias - Wi-Fi 6 e Wi-Fi 6E</h1>
            {/* <img src={Problema} alt='problema' className='mb-0' /> */}
            <Card className="text-center">
              <Card.Header>
                Revolução na Conectividade.
              </Card.Header>
              <Card.Body>
                {/* <Card.Title>Coleta de Informações e Análise do Ambiente</Card.Title> */}
                <Card.Text>
                  <div className='optios'>
                    <div className='optios-header'>
                      <p>
                        Com a crescente demanda por conexões de internet mais rápidas e estáveis, especialmente em um mundo cada vez
                        mais digital e conectado, surgiram novas tecnologias para atender a essas necessidades. Wi-Fi 6 (802.11ax)
                        e Wi-Fi 6E são as últimas inovações no campo das redes sem fio, prometendo melhorias significativas em
                        termos de velocidade, capacidade e eficiência. Este artigo explora as vantagens, desvantagens,
                        tecnologias envolvidas, área de cobertura, principais problemas e custo dessas novas tecnologias.
                      </p>
                    </div>

                    <div className='optios-list'>
                      <h3> <img src={Vantagem} alt='vantagem' /> Vantagens do Wi-Fi 6 e Wi-Fi 6E</h3>
                      <p>
                        <strong>1. Velocidade Melhorada: </strong>
                      </p>
                      <span>
                        - Wi-Fi 6: Oferece velocidades teóricas de até 9,6 Gbps, uma melhoria significativa em relação ao Wi-Fi 5 (802.11ac).
                      </span>
                      <span>
                        - Wi-Fi 6E: Expande essas capacidades para a faixa de 6 GHz, proporcionando ainda mais largura de banda e menos congestionamento.
                      </span>
                    </div>
                    <div className='optios-list'>
                      <p>
                        <strong>2. Maior Capacidade: </strong>
                      </p>
                      <span>
                        - Wi-Fi 6: Utiliza OFDMA (Orthogonal Frequency Division Multiple Access) para permitir que vários dispositivos compartilhem o mesmo canal, melhorando a eficiência do espectro.
                      </span>
                      <span>
                        - Wi-Fi 6E: Com a nova faixa de 6 GHz, há mais canais disponíveis, reduzindo a interferência e aumentando a capacidade de dispositivos conectados.
                      </span>

                    </div>
                    <div className='optios-list'>
                      <p>
                        <strong>3. Eficiência Energética: </strong>
                      </p>
                      <span>
                        - Target Wake Time (TWT) é uma funcionalidade que ajuda a reduzir o consumo de energia em dispositivos IoT,
                        permitindo que eles "despertem" apenas quando necessário para transmitir ou receber dados.
                      </span>
                    </div>
                    <div className='optios-list'>
                      <p>
                        <strong>4. Latência Reduzida: </strong>
                      </p>
                      <span>
                        - A redução da latência é crítica para aplicações como jogos online, videoconferências e realidade aumentada/virtual.
                        Wi-Fi 6 e 6E proporcionam uma latência significativamente menor em comparação com as gerações anteriores.
                      </span>
                    </div>
                    <div className='desvantagens'>

                      <div className='optios-list'>
                        <h3><img src={Desvantagem} alt='desvantagem' /> Desvantagens do Wi-Fi 6 e Wi-Fi 6E</h3>
                        <p>
                          <strong>1. Custo Inicial: </strong>
                        </p>
                        <span>
                          - Dispositivos compatíveis com Wi-Fi 6 e 6E, como roteadores e adaptadores, tendem a ser mais caros devido à tecnologia avançada.
                        </span>
                      </div>
                      <div className='optios-list'>
                        <p>
                          <strong>2. Compatibilidade: </strong>
                        </p>
                        <span>
                          - Para aproveitar os benefícios completos, todos os dispositivos na rede precisam ser compatíveis com Wi-Fi 6 ou 6E,
                          o que pode exigir a atualização de hardware.
                        </span>
                      </div>
                      <div className='optios-list'>
                        <p>
                          <strong>3. Cobertura: </strong>
                        </p>
                        <span>
                          - Embora a cobertura seja robusta, a faixa de 6 GHz usada pelo Wi-Fi 6E tem um alcance menor em comparação com as
                          bandas de 2,4 GHz e 5 GHz, o que pode exigir mais pontos de acesso em áreas maiores.
                        </span>
                      </div>
                      <div className='optios-list'>
                        <h3><img src={Tecnologia} alt='tech' /> Tecnologias Envolvidas</h3>
                      </div>
                      <div className='optios-list'>
                        <p>
                          <strong>1. OFDMA (Orthogonal Frequency Division Multiple Access): </strong>
                        </p>
                        <span>
                          - Permite que múltiplos usuários compartilhem um único canal simultaneamente, aumentando a eficiência do uso do espectro.
                        </span>
                      </div>
                      <div className='optios-list'>
                        <p>
                          <strong>2. MU-MIMO (Multi-User Multiple Input Multiple Output): </strong>
                        </p>
                        <span>
                          - Melhora a capacidade de comunicação com múltiplos dispositivos simultaneamente, tanto na direção de downlink quanto de uplink.
                        </span>
                      </div>
                      <div className='optios-list'>
                        <p>
                          <strong>3. BSS Coloring: </strong>
                        </p>
                        <span>
                          - Ajuda a identificar e reduzir a interferência entre redes vizinhas, melhorando a eficiência da rede.
                        </span>
                      </div>
                      <div className='optios-list'>
                        <p>
                          <strong>4. 1024-QAM (Quadrature Amplitude Modulation): </strong>
                        </p>
                        <span>
                          - Aumenta a eficiência da transmissão de dados, permitindo que mais dados sejam transmitidos no mesmo espaço espectral.
                        </span>
                      </div>
                      <div className='optios-list'>
                        <h3><img src={Sinal} alt='sinal' /> Área de Cobertura</h3>
                        <p>
                          <strong>1. Wi-Fi 6:</strong>
                        </p>
                        <span>
                          Oferece uma cobertura semelhante ao Wi-Fi 5,
                          mas com melhor desempenho em ambientes densos devido a tecnologias como OFDMA e MU-MIMO.
                        </span>
                        <div className='optios-list'>
                          <p>
                            <strong>2. Wi-Fi 6E:</strong>
                          </p>
                          <span>
                            A nova faixa de 6 GHz oferece menos interferência, mas seu alcance é mais limitado em
                            comparação com as bandas de 2,4 GHz e 5 GHz.
                          </span>
                        </div>
                        <div className='optios-list'>
                          <p>
                            <strong>3. Interferência:</strong> Apesar das melhorias, ambientes muito congestionados ainda
                          </p>
                          <span>
                            podem enfrentar interferência, especialmente nas faixas mais usadas.
                          </span>
                        </div>
                        <div className='optios-list'>
                          <p>
                            <strong>4. Penetração de Sinal:</strong>
                          </p>
                          <span>
                            A faixa de 6 GHz tem mais dificuldade em
                            penetrar paredes e outros obstáculos, limitando a cobertura em ambientes fechados.
                          </span>
                        </div>

                      </div>
                      <div className='optios-list'>
                        <h3><img src={Custo} alt='custo' /> Custo de Implementação</h3>
                        <p>
                        </p>
                        <span>
                          - Atualizar para Wi-Fi 6 e 6E pode ser caro, especialmente para grandes empresas com muitos dispositivos.
                          - Roteadores Wi-Fi 6 e 6E são mais caros do que os modelos anteriores.
                          - Empresas podem enfrentar custos elevados para atualizar toda a infraestrutura,
                          mas os benefícios a longo prazo em termos de desempenho e capacidade podem justificar o investimento.
                          - No entanto, os preços estão caindo à medida que a tecnologia se torna mais comum.
                        </span>
                      </div>
                    </div>
                  </div>
                </Card.Text>
                {/* <Button variant="primary">Go somewhere</Button> */}
              </Card.Body>
              <Card.Footer className="text-muted">
                <div className='optios-list-footer'>

                <h3>                  
                  Conclusão
                </h3>
                <p>
                  Wi-Fi 6 e Wi-Fi 6E representam um avanço significativo na tecnologia de redes sem fio, 
                  oferecendo velocidades mais rápidas, maior capacidade e melhor eficiência energética. 
                  Embora existam alguns desafios, como custos iniciais mais altos e cobertura limitada 
                  para a faixa de 6 GHz, as vantagens superam as desvantagens para a maioria dos usuários. 
                  Com o tempo, espera-se que essas tecnologias se tornem o padrão para redes sem fio,
                  proporcionando uma experiência de conectividade superior para consumidores e empresas.
                </p>
                </div>
              </Card.Footer>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}

export default Wifi62;
